import type {z} from "zod";

import {ListLeadsQueryParams} from "@project/sdk/sales/zod";

export const listLeadsSearchSchema = ListLeadsQueryParams.extend({
  page: ListLeadsQueryParams.shape.page.catch(1).default(1),
  perPage: ListLeadsQueryParams.shape.perPage.catch(20).default(20),
  q: ListLeadsQueryParams.shape.q.catch(undefined),
  sortKey: ListLeadsQueryParams.shape.sortKey.catch("leadId"),
  sortDir: ListLeadsQueryParams.shape.sortDir.catch("asc").default("asc"),
  state: ListLeadsQueryParams.shape.state.catch("ACTIVE"),
  countryCodes: ListLeadsQueryParams.shape.countryCodes.catch(undefined),
  environments: ListLeadsQueryParams.shape.environments.catch(undefined),
  createdFrom: ListLeadsQueryParams.shape.createdFrom.catch(undefined),
  createdBefore: ListLeadsQueryParams.shape.createdBefore.catch(undefined),
});

export type ListLeadsSearchInput = z.input<typeof listLeadsSearchSchema>;
export type ListLeadsSearch = z.output<typeof listLeadsSearchSchema>;
